import { createAction, handleActions } from 'redux-actions';

import { List, Map, fromJS } from 'immutable';
import { pender } from 'redux-pender';

import * as common from 'libs/commonFunc';
import * as eduLib from 'libs/eduLib';
import * as normalizer from 'libs/normalizer';

// action types
const INITIAL_STORE = 'edu/INITIAL_STORE';
const CHANGE_EDU = 'edu/CHANGE_EDU';
const CHANGE_EDU_PARAM = 'currentStatus/CHANGE_EDU_PARAM';
const CHANGE_EDU_TARGET_PARAM = 'currentStatus/CHANGE_EDU_TARGET_PARAM';
const CHANGE_EDU_QUIZ_PARAM = 'edu/CHANGE_EDU_QUIZ_PARAM';
const GET_EDU_EXAM = 'edu/GET_EDU_EXAM';
const GET_EDU = 'edu/GET_EDU';
const GET_EDU_TARGET = 'edu/GET_EDU_TARGET';
const GET_EDU_ATTACH = 'edu/GET_EDU_ATTACH';
const GET_EDU_TAG = 'edu/GET_EDU_TAG';
const POST_EDU = 'edu/POST_EDU';
const PUT_EDU = 'edu/PUT_EDU';
const DELETE_EDU = 'edu/DELETE_EDU';

const GET_EDU_QUIZ = 'edu/GET_EDU_QUIZ';
const POST_EDU_QUIZ = 'edu/POST_EDU_QUIZ';
const PUT_EDU_QUIZ = 'edu/PUT_EDU_QUIZ';
const DELETE_EDU_QUIZ = 'edu/DELETE_EDU_QUIZ';

const GET_EDU_MODAL_QUIZ = 'edu/GET_EDU_MODAL_QUIZ';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeEdu = createAction(CHANGE_EDU);
export const changeEduParam = createAction(CHANGE_EDU_PARAM);
export const changeEduTargetParam = createAction(CHANGE_EDU_TARGET_PARAM);
export const changeEduQuizParam = createAction(CHANGE_EDU_QUIZ_PARAM);
export const getEduExam = createAction(GET_EDU_EXAM, eduLib.getEduExamAPI);
export const getEdu = createAction(GET_EDU, eduLib.getEduAPI);
export const getEduTarget = createAction(GET_EDU_TARGET, eduLib.getEduTargetAPI);
export const getEduAttach = createAction(GET_EDU_ATTACH, eduLib.getEduAttachAPI);
export const getEduTag = createAction(GET_EDU_TAG, eduLib.getEduTagAPI);
export const postEdu = createAction(POST_EDU, eduLib.postEduAPI);
export const putEdu = createAction(PUT_EDU, eduLib.putEduAPI);
export const deleteEdu = createAction(DELETE_EDU, eduLib.deleteEduAPI);
// 퀴즈
export const getEduQuiz = createAction(GET_EDU_QUIZ, eduLib.getEduQuizAPI);
export const postEduQuiz = createAction(POST_EDU_QUIZ, eduLib.postEduQuizAPI);
export const putEduQuiz = createAction(PUT_EDU_QUIZ, eduLib.putEduQuizAPI);
export const deleteEduQuiz = createAction(DELETE_EDU_QUIZ, eduLib.deleteEduQuizAPI);

export const getEduModalQuiz = createAction(GET_EDU_MODAL_QUIZ, eduLib.getEduModalQuizAPI);

// initial state
const initialState = Map({
  // 새로고침
  needReload: false,
  page: 1,
  totalPages: 0,
  totalTarget: 0,
  totalEdu: 0,
  param: Map({
    filter: Map({}),
    sort: [{ field: 'eduNo', order: 'DESC' }],
    offset: 0,
    limit: 50
  }),
  // 필터 리스트
  //filter: Map({}),
  // 교육 리스트
  eduSummaryOrdering: List([]),
  eduSummaryByEduNo: Map({}),
  // 대상자 리스트
  eduTargetOrdering: List([]),
  eduTargetDataByTargetNo: Map({}),
  targetParam: Map({
    filter: Map({}),
    sort: [{ field: 'eduNo', order: 'DESC' }],
    offset: 0,
    limit: 30
  }),
  // eduNoArray: List(['all']),
  // 훈련 리스트
  eduExamOrdering: List([]),
  eduExamByExamNo: Map({}),
  examNoArray: Map({}),
  // 태그 리스트
  eduTagOrdering: List([]),
  eduTagByTagNo: Map({}),
  // 교육 컨텐츠 리스트
  eduAttachOrdering: List([]),
  eduAttachByAttachNo: Map({}),
  eduQuizManage: [],
  eduVideoQuizInfo: [],
  totalQuizCount: 0,
  totalQuizPages: 0,
  quizParam: Map({
    filter: {},
    sort: [{ field: 'quizNo', order: 'ASC' }]
  })
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_EDU]: (state, action) => {
      const { name, value } = action.payload;

      return state.set(name, value);
    },
    [CHANGE_EDU_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['param', name], value);
    },
    [CHANGE_EDU_TARGET_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['targetParam', name], value);
    },
    [CHANGE_EDU_QUIZ_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['quizParam', name], value);
    },

    // 교육 리스트 조회
    ...pender({
      type: GET_EDU,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }

        const { list } = action.payload.data;
        const totalEdu = list.length;

        // state = state.set('needReload', false);
        // state = state.set('isMounting', false);

        const examNoArray = {};
        if (list.length > 0) {
          for (let i = 0, l = list.length; i < l; i++) {
            if (list[i].examInfo) {
              examNoArray[list[i].eduNo] = normalizer.examListArrayNormalize(list[i].examInfo, 'examNo');
            }
          }
        }

        return state
          .set('totalEdu', totalEdu)
          .setIn(['eduSummaryOrdering'], fromJS(normalizer.examListArrayNormalize(list, 'eduNo')))
          .setIn(['eduSummaryByEduNo'], fromJS(normalizer.examListNormalize(list, 'eduNo')))
          .set('examNoArray', fromJS(Map(examNoArray)));
      },
      onFailure: (state, action) => {
        // return state.set('eduSummaryOrdering', List([])).set('eduSummaryByEduNo', Map({}));
        return state;
      }
    }),

    // 교육 대상 조회
    ...pender({
      type: GET_EDU_TARGET,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }
        const { list, filter } = action.payload.data;
        const { refresh, offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = list.length > 0 ? list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);

        state = state.set('needReload', false);

        let curPage = 1;
        let curArray = [];
        let curData = {};
        if (list.length > 0) {
          if (refresh) {
            state = state.set('totalPages', totalPages).set('totalTarget', totalCount);
            curArray = normalizer.targetArrayNormalize(list);
            curData = normalizer.targetNormalize(list);
          } else {
            curPage = state.get('page') + 1;
            curArray = state
              .get('eduTargetOrdering')
              .toJS()
              .concat(normalizer.targetArrayNormalize(list));
            curData = Object.assign(state.get('eduTargetDataByTargetNo').toJS(), normalizer.targetNormalize(list));
          }
        } else {
          state = state.set('totalTarget', 0).set('totalPages', 0);
        }
        return state
          .set('page', curPage)
          .set('eduTargetOrdering', fromJS(curArray))
          .set('eduTargetDataByTargetNo', fromJS(curData));
      },
      onFailure: (state, action) => {
        return state
          .set('eduTargetOrdering', initialState.get('eduTargetOrdering'))
          .set('eduTargetDataByTargetNo', initialState.get('eduTargetDataByTargetNo'));
      }
    }),

    // 훈련 목록 조회
    ...pender({
      type: GET_EDU_EXAM,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }

        const { list } = action.payload.data;

        return state
          .set('eduExamOrdering', fromJS(normalizer.examArrayNormalize(list)))
          .set('eduExamByExamNo', fromJS(normalizer.examNormalize(list)));
      },
      onFailure: (state, action) => {
        return state.set('eduExamOrdering', initialState.get('eduExamOrdering')).set('eduExamByExamNo', Map({}));
      }
    }),

    // 태그 조회
    ...pender({
      type: GET_EDU_TAG,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }

        const { list } = action.payload.data;

        state = state.set('needReload', false);

        return state
          .setIn(['eduTagOrdering'], fromJS(normalizer.examListArrayNormalize(list, 'tagNo')))
          .setIn(['eduTagByTagNo'], fromJS(normalizer.examListNormalize(list, 'tagNo')));
      },
      onFailure: (state, action) => {
        return state.set('tagDataByTagNo', Map({}));
        // .set('tagInitialOrdering', List([]))
        // .set('tagInitial', Map({}));
      }
    }),

    // 컨텐츠 조회
    ...pender({
      type: GET_EDU_ATTACH,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }

        const { list } = action.payload.data;

        state = state.set('needReload', false);

        return state
          .setIn(['eduAttachOrdering'], fromJS(normalizer.examListArrayNormalize(list, 'eduAttachNo')))
          .setIn(['eduAttachByAttachNo'], fromJS(normalizer.examListNormalize(list, 'eduAttachNo')));
      },
      onFailure: (state, action) => {
        //
      }
    }),

    // 교육 실시
    ...pender({
      type: POST_EDU,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }

        const error = action.payload.data.isValidLicense;

        if (error !== 0) {
          const { list } = action.payload.data;

          const examNoArray = {};
          if (list.length > 0) {
            if (list[0].examInfo) {
              examNoArray[list[0].eduNo] = normalizer.examListArrayNormalize(list[0].examInfo, 'examNo');
            }
          }

          return state
            .set('totalEdu', state.get('totalEdu') + 1)
            .mergeIn(['examNoArray'], fromJS(Map(examNoArray)))
            .setIn(['eduSummaryOrdering'], state.getIn(['eduSummaryOrdering']).unshift(fromJS(list[0].eduNo)))
            .mergeIn(['eduSummaryByEduNo'], fromJS(normalizer.examListNormalize(list, 'eduNo')));
        } else {
          return state;
        }
      },
      onFailure: (state, action) => {
        return state;
      }
    }),

    // 교육 수정
    ...pender({
      type: PUT_EDU,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const examNoArray =
          list[0].examInfo === null ? [] : normalizer.examListArrayNormalize(list[0].examInfo, 'examNo');

        return state
          .setIn(['examNoArray', String(list[0].eduNo)], examNoArray)
          .setIn(['eduSummaryByEduNo', String(list[0].eduNo)], fromJS(list[0]));
      },
      onFailure: (state, action) => {
        return state.set('eduSummaryOrdering', List([])).set('eduSummaryByEduNo', Map({}));
      }
    }),
    // 교육 삭제
    ...pender({
      type: DELETE_EDU,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        // const { targetNo } = action.payload.config.params;
        const index = state.getIn(['eduSummaryOrdering']).findIndex(eduNo => eduNo === list[0].eduNo);

        return state
          .set('totalEdu', state.get('totalEdu') - 1)
          .setIn(['eduSummaryOrdering'], state.getIn(['eduSummaryOrdering']).delete(index))
          .set('eduSummaryByEduNo', state.get('eduSummaryByEduNo').delete(list[0].eduNo));
      },
      onFailure: (state, action) => {
        //
      }
    }),
    // ------------------- 퀴즈 영역 -------------------
    // 교육하기 퀴즈 조회
    ...pender({
      type: GET_EDU_QUIZ,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }

        const { offset, limit } = action.payload.config.params;
        const { list } = action.payload.data;

        // 전체 목록 수
        const totalQuizCount = list.length > 0 ? list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalQuizPages = Math.ceil(totalQuizCount / limit);

        state = state.set('needReload', false);
        state = state.set('isMounting', false);

        return state
          .set('totalQuizCount', totalQuizCount)
          .set('totalQuizPages', totalQuizPages)
          .set('eduQuizManage', list);
      },
      onFailure: (state, action) => {
        return state
          .set('totalQuizCount', 0)
          .set('totalQuizPages', 0)
          .set('eduQuizManage', []);
        // return state.set('eduSummaryOrdering', List([])).set('eduSummaryByEduNo', Map({}));
      }
    }),

    // 교육하기 퀴즈 등록
    ...pender({
      type: POST_EDU_QUIZ,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }
      },
      onFailure: (state, action) => {
        //
      }
    }),

    // 교육하기 퀴즈 수정
    ...pender({
      type: PUT_EDU_QUIZ,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }
      },
      onFailure: (state, action) => {
        //
      }
    }),

    // 교육하기 퀴즈 삭제
    ...pender({
      type: DELETE_EDU_QUIZ,
      onSuccess: (state, action) => {
        // return state.set('needReload', true);
        if (typeof action.payload === 'undefined') {
          return state;
        }
      }
    }),

    // 교육 실시 모달 퀴즈 리스트 조회
    ...pender({
      type: GET_EDU_MODAL_QUIZ,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }

        const { list } = action.payload.data;
        // const totalQuizCount = list.length;

        state = state.set('needReload', false);
        state = state.set('isMounting', false);


        return state
          .set('eduVideoQuizInfo', list);
        // .set('totalQuizCount', totalQuizCount)
      },
      onFailure: (state, action) => {
        return state.set('eduVideoQuizInfo', []);
        // return state.set('eduSummaryOrdering', List([])).set('eduSummaryByEduNo', Map({}));
      }
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/edu.js